:host {
  font-family: var(--ai12z-bot-font-family) !important;
  font-size: var(--ai12z-bot-font-size) !important;
}
/* Basic styles for the floating icon */
.floating-icon {
  position: fixed;
  cursor: pointer;
  top: 90%;
  transform: translateY(-50%);
  background-color: var(--ai12z-bot-primary-bgcolor);
  color: var(--ai12z-bot-primary-color);
  padding: 10px;
  border-radius: 50%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 1000; /* Ensure it stays above other content */
}
.custom-floating-icon {
  position: fixed;
  cursor: pointer;
  top: 90%;
  transform: translateY(-50%);
  z-index: 1000;
}
/* Left position */
.left {
  left: 10px;
}
/* Right position */
.right {
  right: 10px;
}

.minimizebtn {
  margin: 10px;
}
.chat-window.minimized {
  width: 350px;
  height: 50px;
  overflow: hidden;
}

/* Chat window styles */
.chat-window {
  position: fixed;
  bottom: 20px;
  /* right: 70px; */
  /* width: 350px; */
  /* width: 35%; */
  /* height: 80%; */
  background-color: var(--ai12z-bot-primary-color);
  border: 1px solid #ccc;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  z-index: 1000;
  opacity: 0;
  transform: translateY(20px);
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}

.chat-left {
  left: 70px;
}

.chat-right {
  right: 70px;
}

@keyframes fadeInSlideUp {
  0% {
    opacity: 0;
    transform: translateY(20px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes fadeOutSlideDown {
  0% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateY(20px) scale(0.9);
  }
}

/* Chat window open animation */
.chat-window-open {
  /* opacity: 1; */
  /* transform: translateY(0); */
  animation: fadeInSlideUp 0.4s ease-out forwards;
  pointer-events: auto;
}

/* Chat window close animation */
.chat-window-close {
  /* opacity: 0; */
  /* transform: translateY(20px); */
  pointer-events: none;
  animation: fadeOutSlideDown 0.3s ease-in forwards;
}

.chat-header {
  background-color: var(--ai12z-bot-primary-bgcolor);
  color: var(--ai12z-bot-primary-color);
  padding: 10px;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  border-top-left-radius: 10px; /* Rounded top corners */
  border-top-right-radius: 10px; /* Rounded top corners */
  height: 56px;
}

.chat-name {
  flex-grow: 1;
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}

.header-title {
  margin: 0 0 0 14px;
  padding: 1px 0;
  font-size: 14px;
  line-height: 14px;
}

.chat-body {
  /* padding: 10px; */
  /* height: 350px; */
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-x: hidden;
  /* scrollbar-width: none; */
}

.chat-body::-webkit-scrollbar {
  width: 5px; /* Thin width for the scrollbar */
  height: 5px; /* Thin height for horizontal scrollbar */
}

.chat-body::-webkit-scrollbar-thumb {
  background-color: #888; /* Color of the thumb */
  border-radius: 10px; /* Rounded corners */
}

.message {
  /* max-width: 70%; */
  padding: 10px;
  border-radius: 15px;
  font-size: 14px;
  line-height: 1.4;
  word-wrap: break-word;
}

.message-user {
  align-self: flex-end;
  /* background-color: #007bff; */
  color: var(--ai12z-bot-primary-color);
  /* border-top-right-radius: 0; */
}

.message-text {
  max-width: 100%;
  display: inline-block;
  position: relative;
}

.message-bot {
  /* padding: 10px; */
  align-self: flex-start;
  background-color: var(--ai12z-bot-secondary-bgcolor);
  color: var(--ai12z-bot-secondary-color);
  border-top-left-radius: 0;
  flex-direction: row;
  border-radius: 7px;
}

.msg-wrapper {
  display: flex;
}

.bot-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}

.message-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: fit-content;
}

.message-timestamp {
  font-size: 0.75rem; /* Smaller font size for timestamp */
  color: var(--ai12z-bot-text-mute); /* Light gray color for timestamp */
  margin-top: 2px; /* Space between message text and timestamp */
  align-self: flex-end; /* Align timestamp to the right for user messages */
}

.chat-footer {
  flex-direction: column;
  padding: 10px;
  display: flex;
  border-bottom-left-radius: 10px; /* Rounded bottom corners */
  border-bottom-right-radius: 10px; /* Rounded bottom corners */
  border-top: 1px solid var(--ai12z-bot-primary-bgcolor);
}

.chat-footer textarea {
  flex-grow: 1;
  padding: 5px;
  /* border: 1px solid #ccc; */
  border-radius: 6px;
  margin-right: 5px;
  resize: none;
  scrollbar-width: thin;
  overflow: hidden;
}

.chat-footer textarea:focus {
  outline: none;
  border-color: var(--ai12z-bot-primary-bgcolor);
}

.chat-footer button {
  color: var(--ai12z-bot-primary-bgcolor);
}

.chat-footers button {
  color: var(--ai12z-bot-primary-color);
  border: none;
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
}

.close-btn {
  background: none;
  border: none;
  color: var(--ai12z-bot-primary-color);
  font-size: 20px;
  cursor: pointer;
}

.timestamp {
  font-size: 10px;
  color: var(--ai12z-bot-text-mute);
  margin: 14px 0;
  text-align: center;
  text-transform: uppercase;
}

span.prose {
  font-size: 14px; /* Override p font size */
}
.message-user span.prose {
  color: var(--ai12z-bot-primary-color);
  background-color: var(--ai12z-bot-primary-bgcolor);
  padding: 10px;
  border-radius: 6px;
}

#fileInput {
  display: none;
}
.custom-attachment {
  cursor: pointer;
  /* width: 5%; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-Container {
  position: relative;
  display: inline-block;
  margin-right: 10px;
}
.delete-image {
  opacity: 3;
  position: absolute;
  right: 3px;
  top: 0;
  cursor: pointer;
  line-height: 10px;
}

.ai12zBtn {
  background-color: var(--ai12z-bot-primary-bgcolor) !important;
  color: var(--ai12z-bot-primary-color);
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-decoration: none;
  margin: 5px;
}

.hamburger {
  font-size: 30px;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding-right: 12px;
}

@keyframes zoomIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes zoomOut {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(0);
    opacity: 0;
  }
}
.menu {
  position: absolute;
  top: 55px;
  left: 0;
  width: 200px;
  background-color: var(--ai12z-bot-nav-bgcolor);
  color: var(--ai12z-bot-primary-color);
  overflow: hidden;
  transform-origin: top left;
}
.menu.open {
  animation: zoomIn 0.5s forwards; /* Zoom in when opening */
}

.menu.closed {
  /* visibility: hidden;
  opacity: 0; */
  animation: zoomOut 0.5s forwards; /* Zoom out when closing */
}

.menu ul {
  list-style-type: none;
  padding: 10px;
}
.custom-privacy {
  color: var(--ai12z-bot-privacy-color);
  padding-bottom: 10px;
  padding-left: 5px;
  margin-top: auto; /* Pushes the footer to the bottom */
}
.menu ul li {
  padding: 10px;
  cursor: pointer;
}
/* Media query for mobile devices */
@media (max-width: 768px) {
  /* Initially show the chatbot */

  /* Hide the chatbot when the 'hide-chatbot' class is applied */
  .hide-chatbot {
    display: none;
  }

  .chat-window {
    width: 100% !important;
    height: 100% !important;
    right: 0%;
    bottom: 0%;
  }
  .pagination-controls button {
    padding: 5px 5px;
  }
}
.follow-up {
  display: flex;
  cursor: pointer;
  gap: 0.5rem;
  color: var(--ai12z-bot-followup-color);
  font-size: var(--ai12z-bot-followup-font-size);
}
.custom-svg-checkbox {
  margin-top: 0.25rem;
  width: 1rem;
  height: 1rem;
  position: absolute;
}
.follow-up-input {
  appearance: none;
  width: 1rem;
  height: 1rem;
  border-width: 2px;
  flex-shrink: 0;
  margin-top: 0.25rem;
  border-radius: 0.125rem;
  border-color: rgb(59 130 246);
}

.follow-up-input:checked {
  background-color: var(--ai12z-bot-followup-bg-color);
  border-width: 0px;
}

.bubble-width {
  width: 90%;
}
